import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { SpecialValidators } from 'ish-shared/forms/validators/special-validators';

import { FieldLibraryConfiguration } from './field-library-configuration';

/**
 * City, required by default
 */
@Injectable()
export class CityConfiguration extends FieldLibraryConfiguration {
  id = 'city';

  getFieldConfig(): FormlyFieldConfig {
    return {
      type: 'ish-text-input-field',
      props: {
        label: 'account.address.city.label',
        required: true,
        maxLength: 35,
      },
      validators: {
        validation: [SpecialValidators.noOnlyWhiteSpaces],
      },
      validation: {
        messages: {
          required: 'account.address.city.error.required',
          noOnlyWhiteSpaces: 'account.address.city.error.required',
        },
      },
    };
  }
}
